module.exports = __webpack_public_path__ + "img/ring_r_e_null_0@2x.28f8cccb.png";